import { render } from "./EllipsisIcon.vue?vue&type=template&id=495aa88e&scoped=true"
const script = {}

import "./EllipsisIcon.vue?vue&type=style&index=0&id=495aa88e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495aa88e"]])

export default __exports__